require('../../modules/es6.symbol');
module.exports = require('../../modules/$').core.Symbol;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/symbol/index.js
 ** module id = 583
 ** module chunks = 0
 **/